import { initContract } from '@ts-rest/core'
import { animalAnimalsContract } from './animals/animals.contract'
import { animalCatsContract } from './cats/cats.contract'
import { animalDogsContract } from './dogs/dogs.contract'

const c = initContract()

export const animalServiceContract = c.router(
  {
    animals: animalAnimalsContract,
    dogs: animalDogsContract,
    cats: animalCatsContract,
  },
)
